

import React from 'react'
import Layout from '../../components/layout'
import Map from '../../components/map';

import { useState } from 'react'
import MessageForm from '../../components/MessageForm';
import QouteCard from '../../components/qoutecard';

import avatar_kg from '../../assets/employees/kalle-profil.jpg'

export default function ContactPage() {

  const [selectedSite, setSelectedSite] = useState("")
  const quote = `Modernisera och säkra ert nätverk med oss!

  Kontakta oss för mer information!`

  return (
    <Layout>
      <div id="contact" className="section">
        <div className='flex flex-col space-y-5'>
          <div className='flex flex-row justify-center'>
            <QouteCard
              name={"Kalle Gustafsson"}
              title={"Account Manager"}
              phone={"072-602 16 06"}
              qoute={quote}
              avatar={avatar_kg}
              email={"kalle.gustafsson@acebit.se"}
            />

          </div>
          <div className='flex sm:flex-row flex-col justify-between'>
            <div className='flex flex-col flex-grow justify-center items-center'>
              <MessageForm></MessageForm>
            </div>
            <div className='flex flex-col overflow-hidden'>
              <Map
                selectedSite={selectedSite}
                setSelectedSite={setSelectedSite}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
